
import AppBrowse from "@/components/browse/Browse.vue";
import AppCodaImport from "@/components/bank/CodaImport.vue";
import AppBankBalance from "@/components/bank/BankBalance.vue";
import AppCashierCheck from "@/components/cashier/CashierCheckModal.vue";
import { Bank } from "@/models/base";
import { BankService } from "@/services/bank-service";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import { BrowseState } from "@/utils/browse/browse-state";
import Vue from "vue";
import { UserConfigService } from "../../services/user-config-service";
import { MODULE } from "../../config/modules";
import { ISelectItem } from "node_modules/winfakt-vue-components/src/winfakt-vue-components";
import { AuthService } from "@/services/auth-service";
import { IQueryParams } from "@/utils/query-params";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { BankAwsFile } from "@/models/base/bank-aws-file";
import AppCreateBankTransfer from "@/components/bank/CreateBankTransfer.vue";
import AppCodaboxModal from "@/components/bank/CodaBoxModal.vue";
import { DossierConfigService } from "@/services/dossier-config-service";

export default Vue.extend({
	data() {
		return {
			codaUpload: false,
			bankBalance: false,
			cashierCheck: false,
			createTransferOpen: false,
			codaBoxOpen: false,
			selectedItems: [] as Bank[],
			browseState: null as null | BrowseState,
		};
	},
	props: {
		browseId: Number,
	},
	computed: {
		hasModule():boolean {
			return AuthService.hasModule(MODULE.BANKGEGEVENS_VERWERKEN);
		},
		dataSource(): IBrowseDataSource<Bank> {
			let elem = this;
			return {
				getFullElement: (el:Bank)=>BankService.getBooking(el.ID),
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: (params:IQueryParams) => BankService.get(params),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return BankService.getTotals(view);
				},
				edit(bank: Bank) {
					elem.$router.push(`/bank/edit/${bank.ID}`);
				},
				info(bank: Bank) {
					elem.$router.push(`/bank/info/${bank.ID}`);
				},
				async delete(elements:Bank[]){
					await BankService.deleteBookings(elements);
					return true;
				},
				addRoute(view: View) {
					let newTypeID = view.MetaData.NewBankTypeID || 1;
					return `/bank/new?typeId=${newTypeID}`;
				},
				browseName: "Banks",
				modelName: "Bank",
				canEdit: (bank:Bank):boolean=>{
					return elem.hasModule;
				},
				canCreate: elem.hasModule,
				browsePermissions: ()=>UserConfigService.getPermissionSettings().BankPermissions,
				canMakeReports: elem.hasModule,
				getDocumentsDataSource: (v:Bank)=>BankAwsFile.getDataSource(v),
				extraFieldSettings: {
					getExtraFields: BankService.getExtraFields.bind(BankService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().BankNames,
					batchEdit: BankService.batchEditExtraField.bind(BankService),
					edit: (BankService.updateExtraFields as any).bind(BankService)
				}
			};
		},
		hasCodaBox(): boolean {
			return DossierConfigService.getCodaBoxConfig().Connected;
		},
		buttonBarItems(): ISelectItem<Function>[] {
			let items = [
				{text: this.$ct("bank-balance").toString(), value: this.showBankBalance.bind(this), icon: "balance-scale"},
				{text: this.$ct("import-coda").toString(), value: this.showImportModal.bind(this), icon: "history"},
				{text: this.$ct("cashier-check").toString(), value: this.showCachierCheck.bind(this), icon: "cash-register"},
				{text: this.$ct("create-transfer").toString(), value: this.createTransfer.bind(this), icon: "exchange-alt"}
			];
			if (this.hasCodaBox) {
				items.push({text: "CodaBox", value: this.showCodaBox.bind(this), icon: "cloud-download-alt"});
			}
			return items;
		},
	},
	watch: {
		"$route.path": {
			immediate: true,
			handler(){
				if (this.$route.path == "/bank"){
					ToolbarService.title = this.$ct("bank");
				}
			}
		}
	},
	methods: {
		showImportModal() {
			this.codaUpload = true;
		},
		showBankBalance() {
			this.bankBalance = true;
		},
		showCachierCheck() {
			this.cashierCheck = true;
		},
		refresh(){
			((this.$refs.browse as any).state as BrowseState).fetch();
		},
		updateView() {
			if (!this.browseState) return;
			this.browseState.fetch();
		},
		createTransfer(){
			this.createTransferOpen=true;
		},
		showCodaBox(){
			this.codaBoxOpen=true;
		}
	},
	components: {
		AppBrowse,
		AppCodaImport,
		AppBankBalance,
		AppCashierCheck,
		AppCreateBankTransfer,
		AppCodaboxModal
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
